import React, { useEffect } from 'react';
import { env, scriptInjectedFn } from '../../config';

export const liveLoaderProps = {
  dashboard: 'lga',
  year: '2022',
  env: env,
};

const id = 'live-loader';

export const LiveLoader = () => {
  useEffect(() => {
    scriptInjectedFn._grant_hydrate('LiveLoader', liveLoaderProps)(`#${id}`);
  }, []);

  return <div id={id}></div>;
};



// WEBPACK FOOTER //
// ./src/components/live-loader/live-loader.js